import React, { useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../LanguageContext';

const Section = styled.section.attrs({ id: 'contact' })`
  padding: 4rem 1rem;
  max-width: 600px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.grayLight};
  color: ${({ theme }) => theme.colors.grayDark};
  text-align: center;
  border-radius: 10px;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 2px solid ${({ theme }) => theme.colors.greenPrimary};
  border-radius: 6px;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Textarea = styled.textarea`
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 2px solid ${({ theme }) => theme.colors.greenPrimary};
  border-radius: 6px;
  font-family: ${({ theme }) => theme.fonts.primary};
  resize: vertical;
  min-height: 100px;
`;

const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }
`;

const SuccessMessage = styled.p`
  margin-top: 1rem;
  color: ${({ theme }) => theme.colors.greenPrimary};
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Contact = () => {
  const { translations } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://formsubmit.co/ajax/contato@ecofab.com.br', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          company: formData.company,
          message: formData.message,
          _subject: `Novo contato do site - ${formData.name}`,
        })
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          company: '',
          message: '',
        });
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert(translations.contact.errorMessage || 'Error sending message. Please try again.');
    }
  };

  return (
    <Section>
      <Title>{translations.contact.title}</Title>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          placeholder={translations.contact.placeholders.name}
          value={formData.name}
          onChange={handleChange}
          required
          aria-label={translations.contact.placeholders.name}
        />
        <Input
          type="email"
          name="email"
          placeholder={translations.contact.placeholders.email}
          value={formData.email}
          onChange={handleChange}
          required
          aria-label={translations.contact.placeholders.email}
        />
        <Input
          type="text"
          name="company"
          placeholder={translations.contact.placeholders.company}
          value={formData.company}
          onChange={handleChange}
          aria-label={translations.contact.placeholders.company}
        />
        <Textarea
          name="message"
          placeholder={translations.contact.placeholders.message}
          value={formData.message}
          onChange={handleChange}
          required
          aria-label={translations.contact.placeholders.message}
        />
        <Button type="submit">{translations.contact.button}</Button>
      </Form>
      {submitted && <SuccessMessage>{translations.contact.successMessage}</SuccessMessage>}
    </Section>
  );
};

export default Contact;
